document.querySelectorAll('.product__accordion').forEach(function(accordion) {
  const details = accordion.querySelector('details');
  const plusIcon = accordion.querySelector('.plus-icon');
  const minusIcon = accordion.querySelector('.minus-icon');
  console.log('accordions');

  // Función para actualizar la visibilidad de los íconos
  function toggleIcons() {
    if (details.hasAttribute('open')) {
      plusIcon.style.display = 'none';
      minusIcon.style.display = 'block';
    } else {
      plusIcon.style.display = 'block';
      minusIcon.style.display = 'none';
    }
  }

  // Llamar la función al cargar la página
  toggleIcons();

  // Agregar un evento para cuando se abre o cierra el acordeón
  details.addEventListener('toggle', toggleIcons);
});
